module.exports = __webpack_public_path__ + "static/15-c41a388a4169e766654539ffd280d75c.jpg";